import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const QuestionMark = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M9 18C13.9711 18 18 13.9711 18 9C18 4.02891 13.9711 0 9 0C4.02891 0 0 4.02891 0 9C0 13.9711 4.02891 18 9 18ZM5.96953 5.81133C6.24727 5.02734 6.99258 4.5 7.82578 4.5H9.87539C11.1023 4.5 12.0938 5.49492 12.0938 6.71836C12.0938 7.51289 11.6684 8.24766 10.9793 8.64492L9.84375 9.29531C9.83672 9.75234 9.46055 10.125 9 10.125C8.53242 10.125 8.15625 9.74883 8.15625 9.28125V8.80664C8.15625 8.5043 8.31797 8.22656 8.58164 8.07539L10.1391 7.18242C10.3043 7.0875 10.4062 6.91172 10.4062 6.72187C10.4062 6.42656 10.1672 6.19102 9.87539 6.19102H7.82578C7.70625 6.19102 7.60078 6.26484 7.56211 6.37734L7.54805 6.41953C7.39336 6.85898 6.9082 7.0875 6.47227 6.93281C6.03633 6.77812 5.8043 6.29297 5.95898 5.85703L5.97305 5.81484L5.96953 5.81133ZM10.125 12.375C10.125 12.9973 9.62227 13.5 9 13.5C8.37773 13.5 7.875 12.9973 7.875 12.375C7.875 11.7527 8.37773 11.25 9 11.25C9.62227 11.25 10.125 11.7527 10.125 12.375Z"
				id="questionMark"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

QuestionMark.propTypes = {
	color: PropTypes.string,
};

export default QuestionMark;
